import React, { useRef } from 'react';

import PropTypes from 'prop-types';

import { TootipStyle } from './style';

const Tooltip = ({ id, error }) => {
  const refTT = useRef(null);
  return (
    <TootipStyle
      place="top"
      type="light"
      backgroundColor="white"
      textColor="black"
      isCapture
      effect="solid"
      ref={refTT}
      afterShow={() => refTT.current.updatePosition()}
      id={id}
      clickable
      errorInResetPasswordLogin={error}
    />
  );
};

Tooltip.propTypes = {
  id: PropTypes.string,
  error: PropTypes.bool
};

export default Tooltip;
